import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root'
})

export class UtilitarioService {
  
  loading:Boolean = false;
  public busqueda:string = "";
  // daet ini
  public tipobusqueda:string = "";
  public fecIni:string="";
  public fecFin:string="";
  // daet fin
  public categoria:string = "";
  // daet1 ini
  public seccion:string="";
  // daet1 fin
  public idCategoria="";
  public idSeleccionado:string = "";
  public idSubCategoria:string = "";

  public contactoVisible = true;

  constructor(private toastrService:ToastrService) { }

  toastrInfo(mensaje:String){
    this.toastrService.info(mensaje.toString());
  }
  toastrSuccess(mensaje:String){
    this.toastrService.success(mensaje.toString());
  }
  toastrWarning(mensaje:String, titulo?:String){
    this.toastrService.warning(mensaje.toString(), titulo ? titulo.toString() : '');
  }
  toastrError(mensaje:String){
    this.toastrService.error(mensaje.toString());
  }

}
